import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { AppDownloadBanner } from '@gumtree/ui-library';
import { GrowthBookFeature, ExperimentVariant } from '@gumtree/shared/src/model/experiment';
import ErrorBoundary from '../error-boundary';
import { renderHeaderLayout, resolveHeaderLayout } from './header-layout';
import type { ShellState } from '../reducers/common';

const SEARCH_BAR_PAGE_TYPES = ['Homepage', 'ResultsSearch', 'ResultsBrowse'];

const Header = () => {
    const {
        showSimpleHeaderOnly,
        showOnMobile,
        showOnSyiPostFlow,
        pageType,
        showSearchBarOnMobile,
    } = useSelector((state: ShellState) => ({
        showSimpleHeaderOnly: state.simpleHeader?.showOnly,
        showOnMobile: state.baseConfig.device.type === 'mobile',
        showOnSyiPostFlow: ['PostAd', 'EditAd'].includes(state.baseConfig.pageType),
        pageType: state.baseConfig.pageType,
        showSearchBarOnMobile: state.searchBar.showSearchBarOnMobile,
    }));

    const mhhVariant = useFeatureValue(GrowthBookFeature.MHH, ExperimentVariant.VARIANT_A);
    const mhcVariant = useFeatureValue(GrowthBookFeature.MHC, ExperimentVariant.VARIANT_A);
    const whcVariant = useFeatureValue(GrowthBookFeature.WHC, ExperimentVariant.VARIANT_A);
    const isMhhExperiment = mhhVariant === ExperimentVariant.VARIANT_B && showOnMobile;
    const isSearchBarPage = SEARCH_BAR_PAGE_TYPES.includes(pageType);
    const useMhhLayout = isMhhExperiment && (isSearchBarPage || showSearchBarOnMobile);
    const useMhcStickyLayout =
        !useMhhLayout &&
        !showSimpleHeaderOnly &&
        showOnMobile &&
        pageType === 'Homepage' &&
        (mhcVariant === ExperimentVariant.VARIANT_B || mhcVariant === ExperimentVariant.VARIANT_C);
    const useMhcDesktopLayout =
        !showOnMobile && !showSimpleHeaderOnly && whcVariant === ExperimentVariant.VARIANT_C;
    const layout = resolveHeaderLayout({
        useMhhLayout,
        useMhcLayout: useMhcStickyLayout,
        useMhcDesktopLayout,
    });

    return (
        <Fragment>
            <ErrorBoundary>
                <AppDownloadBanner />
                {renderHeaderLayout(layout, {
                    showSimpleHeaderOnly,
                    showOnMobile,
                    showOnSyiPostFlow,
                    isMhhExperiment,
                })}
            </ErrorBoundary>
        </Fragment>
    );
};

export default Header;
